import { render, staticRenderFns } from "./HeaderVariant2.vue?vue&type=template&id=47f7b988&scoped=true&"
import script from "./HeaderVariant2.vue?vue&type=script&lang=js&"
export * from "./HeaderVariant2.vue?vue&type=script&lang=js&"
import style0 from "./HeaderVariant2.vue?vue&type=style&index=0&id=47f7b988&lang=scss&scoped=true&"
import style1 from "./HeaderVariant2.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f7b988",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VSpacer,VToolbar})
